angular.module('app')
  .directive('mediathequeAuteuroeuvreIllustrationInput', AuteuroeuvreIllustrationInputDirective);

function AuteuroeuvreIllustrationInputDirective() {
  return {
    restrict: 'E',
    scope: {
      name: '@mediathequeName',
      id: '@mediathequeId',
      illustrationId: '@mediathequeIllustrationId',
      form: '@mediathequeForm',
      disabled: '&mediathequeDisabled',
      initialValue: '&mediathequeInitialValue',
      applyFocus: '&mediathequeApplyFocus'
    },
    replace: true,
    controller: AuteuroeuvreIllustrationInputController,
    controllerAs: 'inputCtrl',
    templateUrl: 'common/auteuroeuvre-illustration-input.html'
  };
}

/*@ngInject*/
function AuteuroeuvreIllustrationInputController($rootScope, $scope, PersonneEditModal, PersonneService) {
  var inputCtrl = this;

  inputCtrl.editPersonne = editPersonne;
  inputCtrl.createPersonne = createPersonne;

  init();

  // TODO: Ajouter un watcher sur $scope.model (couplé à un $timeout pour s'assurer que le scope est bien à jour)
  // si le model initial est modifié par le composant parent

  function init() {
    inputCtrl.auteuroeuvre = $scope.initialValue() || { professions: [{ libelle: ""}] };
    $rootScope.$on('personne.edit.success', editPersonneSuccess);
  }
  function editPersonneSuccess(event, uniqueId, personneId) {
    // on s'occupe de l'événement si on en est à l'origine ou si la donnée modifiée et la notre
    if (inputCtrl.uniqueId === uniqueId || inputCtrl.auteuroeuvre.auteur.id === personneId) {
      inputCtrl.auteuroeuvre.auteur = PersonneService.getByTemporaryId(personneId);
    }
  }
  function editPersonne() {
    inputCtrl.uniqueId = _.uniqueId('personne.edit.start_');
    PersonneEditModal.updatePersonne(inputCtrl.uniqueId, $scope.illustrationId, inputCtrl.auteuroeuvre.auteur)
  }
  function createPersonne() {
    inputCtrl.uniqueId = _.uniqueId('personne.edit.start_');
    PersonneEditModal.createPersonne(inputCtrl.uniqueId, $scope.illustrationId)
  }
}
